const HasRef = ref => ref && ref.current;
export default HasRef;
